import { useEffect } from "react";
import ModelManagementFilter from './components/ModelManagementFilter';
import ModelManagementMainSection from './components/ModelManagementMainSection';
import { useLocation, useSearchParams } from "react-router-dom";
import "./styles/model-management.scss";
import useModelManagementHook from './hooks/useModelManagementHook';
import useModelManagementStore from './store/useModelManagementStore';

const ModelManagement = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { handler } = useModelManagementHook();
  const { handleGetModels } = handler;
  const { setProjectId, projectId: activeProjectId, setProjects } = useModelManagementStore();

  const locationState = location.state || {};
  const hasRouteProjectId = Object.prototype.hasOwnProperty.call(locationState, "projectId");
  const routeProjectId = hasRouteProjectId ? locationState.projectId : undefined;
  const queryProjectId = searchParams.get("projectId") || undefined;

  const effectiveProjectId = routeProjectId ?? queryProjectId;

  // Sync store with route/query: when no projectId in URL (e.g. top bar "Model Management"),
  // clear store so we show ALL models; when projectId is in URL, use it.
  useEffect(() => {
    if (effectiveProjectId !== undefined) {
      if (effectiveProjectId !== activeProjectId) {
        setProjectId(effectiveProjectId ?? null);
      }
    } else {
      // Navigated without project context (e.g. from top bar) → show all models from all projects
      if (activeProjectId != null) {
        setProjectId(null);
      }
    }
  }, [effectiveProjectId, activeProjectId, setProjectId]);

  useEffect(() => {
    const params = activeProjectId ? { project_id: activeProjectId } : undefined;
    setProjects([]); // prevent showing previous project's models while new fetch completes
    handleGetModels(params);
  }, [handleGetModels, activeProjectId, setProjects]);

  return (
    <div className="container-fluid model-mgmt-page">
      <div className="row">
        <div className="col-12 mt-2">
          <ModelManagementFilter />
        </div>
        <div className="col-12 mt-2">
          <ModelManagementMainSection />
        </div>
      </div>
    </div>
  );
};

export default ModelManagement;